import clsx from "clsx";
import { STEPS } from "@/domains/hud/constants/odometer";
import getCounterFormat from "@/domains/hud/helpers/getCounterFormat";

type Props = {
  cols: number;
  ceilHeight: number;
  value: string | number;
  unit?: string;
  direction?: "left" | "right";
  disableNotUsedCeil?: boolean;
  className?: string;
  classNameCeil?: string;
  classNameStep?: string;
};

export default function IndicatorCounter({
  value,
  cols,
  unit,
  direction = "left",
  disableNotUsedCeil = false,
  className,
  classNameCeil,
  classNameStep,
  ceilHeight,
}: Props) {
  const counter = getCounterFormat(value, cols, direction);

  return (
    <div className={clsx("relative flex", className)}>
      {counter.map((item, index) => (
        <div
          key={`${index + index}`}
          className={clsx(
            "relative flex flex-col items-center justify-center overflow-clip",
            classNameCeil,
            disableNotUsedCeil && !item.isActive ? "opacity-60" : "",
          )}
          style={{ height: `${ceilHeight}px` }}
        >
          <div
            className="absolute flex flex-col items-center gap-[4px] top-0 transition-[transform]"
            style={{ transform: `translate3d(0, ${-item.value * (ceilHeight + 4)}px, 0)` }}
          >
            {STEPS.map((step) => (
              <span
                key={step}
                className={clsx("flex items-center justify-center", classNameStep)}
                style={{ height: `${ceilHeight}px` }}
              >
                {step}
              </span>
            ))}
          </div>
        </div>
      ))}

      {unit && (
        <span className="absolute text-[10px] font-medium text-white -right-4.5 top-[50%] -translate-y-[50%]">
          {unit}
        </span>
      )}
    </div>
  );
}
